<template>
  <ModalImpression :modalId="'modalInfoCommande'" ref="modalInfoCommandeRef" :dialogClass="'modal-dialog modal-lg'"
    @print="printCommande">

    <div class="row align-items-center mb-1">
      <div class="col-md-4">
        <label for="commande_longueur_bois" class="mb-0">Longueur des bûches (cm):</label> {{ commande.longueurBois }}
      </div>
    </div>

    <div class="row align-items-end mb-1">
      <div class="col-md-4">
        <label for="commande_quantite_bois">Nombre de stère:</label> {{ commande.quantiteBois }}
      </div>
      <div class="col-md-4">
        <label for="commande_prix_unitaire_bois">Prix unitaire:</label> {{ commande.prixUnitaireBois }}
      </div>

      <div class="col-md-4 text-center">
        <label>Total : </label>
        {{ (commande.quantiteBois * commande.prixUnitaireBois || 0).toFixed(2) }} €
      </div>
    </div>

    <div class="row align-items-end mb-1">
      <div class="col-md-4">
        <label for="commande_quantite_sac">Nombre de sac:</label> {{ commande.quantiteSac }}
      </div>

      <div class="col-md-4">
        <label for="commande_prix_unitaire_sac">Prix unitaire:</label> {{ commande.prixUnitaireSac }}
      </div>

      <div class="col-md-4 text-center">

        <label>Total :</label>
        {{ (commande.quantiteSac * commande.prixUnitaireSac || 0).toFixed(2) }} €

      </div>
    </div>

    <div class="row align-items-center mb-1">
      <div class="col-md-4">
        <label for="commande_livraison" class="mb-0">Livraison:</label> {{ commande.fraisLivraison.distance }} - {{
          commande.fraisLivraison.prix }}€
      </div>
    </div>
    <div class="row align-items-center mb-1">
      <div class="col-md-4">
        <label for="commande_reduction" class="mb-0">Réduction:</label> {{ commande.reduction|| 0 }} €
      </div>
    </div>

    <div class="row align-items-center mb-3">
      <div class="col-md-12 text-center">
        <div class="border bg-light" style="border-radius: 10px;">
          <label class="font-weight-bold">Total Global : </label>
          <span class="font-weight-bold">
            {{
              (
                (commande.quantiteBois * commande.prixUnitaireBois || 0) +
                (commande.quantiteSac * commande.prixUnitaireSac || 0) +
                (parseFloat(commande.fraisLivraison.prix) || 0) -
                (commande.reduction || 0)
              ).toFixed(2)
            }} €
          </span>
        </div>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-md-6">
        <label for="commande_date_creation">Date de création:</label> {{ commande.dateCreation }}
      </div>

      <div class="col-md-6">
        <label for="commande_date_livraison_prev">Date de livraison:</label> {{ commande.livraison ? this.format(commande.livraison.dateLivraison ) : '' }}
      </div>
    </div>

    <div class="row align-items-center mb-1">
      <div class="col-md-4 d-flex align-items-center">
        <label for="commande_tranche_horaire" class="mb-0">Horaire de livraison:</label> {{ commande.trancheHoraire }}
      </div>
    </div>

    <div class="row align-items-center mb-1">
      <div class="col-md-4 d-flex align-items-center">
        <label for="commande_type_paiement" class="mb-0">Type de paiement:</label> {{ commande.typePaiement }}
      </div>
    </div>

    <div class="row align-items-center mb-1">
      <div class="col-md-4 d-flex align-items-center">
        <label for="commande_num_facture" class="mb-0">Numéro de facture:</label> {{ commande.numFacture }}
      </div>
    </div>

    <div class="row align-items-center mb-1">
      <div class="col-md-4 d-flex align-items-center">
        <label for="commande_notes">Notes:</label>{{ commande.notes }}
      </div>
    </div>

  </ModalImpression>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalImpression from '../../../../components/ModalImpression.vue';
import { generateFicheCommande } from "../../../Document/generationFicheCommande";
import DateFormatService from '@/services/dateFormat.service';

export default {
  name: 'CommandeInfo',
  mixins: [ DateFormatService],
  components: {
    ModalImpression
  },
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({}),
    },

  },
  data() {
    return {
      commande: {
        fraisLivraison: {},
        identite: {},
      },
      errors: [],
    }
  },
  methods: {
    getCommande(id) {
      Axios.get('/commande/' + id).then(res => {
        this.commande = res.data;
      }).catch(err => {
        console.error('Erreur lors du chargement de la commande :', err);
      });
    },
    async printCommande() {
      await generateFicheCommande(this.commande)
    },
  },
  watch: {
    params: {
      handler(params) {
        if (params.id != null) {
          this.getCommande(params.id);
        }
      },
      deep: true,
    },
  }
}
</script>

<style>
.form {
  max-width: 550px;
  margin: 0 auto;
}

.formGroup {
  max-width: 550px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
</style>